import React from 'react';
import EventTitle from './EventTitleHeadline.styles';

export default function EventTitleHeadline(props) {
    return <EventTitle {...props} />;
}

EventTitleHeadline.splash = {
    ...EventTitle.splash,
};
